import { createContext, useContext, type ReactNode } from 'react';

const TechnicalDetailsContext = createContext(false);

export function TechnicalDetailsProvider({
    children,
    showTechnicalDetails,
}: {
    children: ReactNode;
    showTechnicalDetails: boolean;
}) {
    return (
        <TechnicalDetailsContext.Provider value={showTechnicalDetails}>
            {children}
        </TechnicalDetailsContext.Provider>
    );
}

export function useTechnicalDetails(): boolean {
    return useContext(TechnicalDetailsContext);
}
